module.exports = __webpack_public_path__ + "static/img/6.b14317c5.png";